import React, { useContext, useState, useEffect } from 'react'
import Loaders from '@/product/components/molecules/Loaders'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import CustomTable from '@/product/components/molecules/CustomTable'
import settingContext from '@/custom/context/setting/settingContext'

const AuditTrailPopup = (props) => {
    const SettingContext = useContext(settingContext)
    const { audit_trial_data, fetchAuditTrailDetails } = SettingContext

    const [isLoading, setIsLoading] = useState(false)
    const [tableBody, setTableBody] = useState([])
    const { data } = props
    const togglePopup = props.function

    const tableValues = [
        {
            field: 'action_name',
            type: '',
            firstChild: false,
            sort: true,
            sortField: 'p.title',
            disablePadding: false,
            label: 'Action',
        },
        {
            field: 'description',
            type: 'tooltip',
            firstChild: false,
            sort: true,
            sortField: 'p.title',
            disablePadding: false,
            label: 'Description',
            disableTooltip: true,
            tooltipFormat: 'number',
        },
        {
            field: 'email',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'User Email',
        },
        {
            field: 'username',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'User Name',
        },
        {
            field: 'created_at',
            type: 'datetime',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Auditated On',
        },
    ]

    useEffect(() => {
        if (data.popup && data.id) {
            setIsLoading(true)
            fetchAuditTrailDetails({
                page: 1,
                limit: 20,
                filters: {
                    projectId: {
                        value: data.id,
                        type: 'in',
                        field: 'pat.project_id',
                    },
                },
            })
        }
    }, [data])

    useEffect(() => {
        if (audit_trial_data?.records?.length > 0) {
            setTableBody(audit_trial_data.records)
            setIsLoading(false)
        } else if (audit_trial_data?.records?.length === 0) {
            setTableBody([])
            setIsLoading(false)
        }
    }, [audit_trial_data])

    return (
        <FullScreenPopup
            modaltitle={'Audit Trail'}
            open={data.popup && data.status === 'audit_trail'}
            handleClose={() => {
                togglePopup(false)
            }}
        >
            <div className="addUserModal customContainer">
                <div className="dashboard listing">
                    {isLoading ? (
                        <Loaders name="table" isLoading={isLoading} />
                    ) : (
                        <CustomTable
                            formik={{
                                page: 1,
                                limit: 20,
                                filters: {
                                    pid: {
                                        value: data.id,
                                        type: 'in',
                                        field: 'pat.project_id',
                                    },
                                },
                            }}
                            tableBody={tableBody}
                            tableValues={tableValues}
                            tableActions={[]}
                            allData={audit_trial_data}
                            changeTableFunction={fetchAuditTrailDetails}
                        />
                    )}
                </div>
            </div>
        </FullScreenPopup>
    )
}

export default AuditTrailPopup
